import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { getData } from "../../../../newApis/dotNetApiMethods";

export interface IBusinessType {
  id: number;
  name: string;
}

export interface IBusinessTypesResponse {
  data: IBusinessType[];
}

export const getBusinessTypes = async (): Promise<IBusinessTypesResponse> => {
  const { data } = await getData(ajaxEndpoints.DB_GET_BUSINESS_TYPES);
  return data;
};

const useBusinessTypes = () => {
  return useQuery<IBusinessTypesResponse>(["businessTypes"], getBusinessTypes, {
    staleTime: 600000, // 10 minutes
  });
};

export default useBusinessTypes;
